// extracted by mini-css-extract-plugin
export var linksContainer = "LinksSidebar-module--linksContainer--1RmUY";
export var link = "LinksSidebar-module--link--Uk6WJ";
export var icon = "LinksSidebar-module--icon--3-se6";
export var verticalLine = "LinksSidebar-module--verticalLine--3TT7M";